import { BFormText } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBFormText = createEgBootstrapProxy("EgBFormText", BFormText);
